import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'comparisonOperator' })
export class ComparisonOperator implements PipeTransform {

    transform(key: string): string {
        const mappingIcons = {

            'Equal': '=',
            'NotEqual': '!=',
            'GreaterThan': '>',
            'LessThan': '<',
            'GreaterEqualTo': '>=',
            'LessEqualTo': '<=',
            'Any': 'Any'
        };

        return mappingIcons[key] || '';
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/comparisonOperator.pipe.ts